import { diffWordsWithSpace } from "diff";
import type { DiffSegment } from "@/features/ai/ai.types";

export function computeWordDiff(originalText: string, polishedText: string): DiffSegment[] {
  if (originalText === polishedText) {
    return [
      {
        index: 0,
        kind: "unchanged",
        text: originalText,
      },
    ];
  }

  return diffWordsWithSpace(originalText, polishedText)
    .map<DiffSegment | null>((part, index) => {
      const text = part.value;
      if (!text) {
        return null;
      }

      return {
        index,
        kind: part.added ? "added" : part.removed ? "removed" : "unchanged",
        text,
      };
    })
    .filter((segment): segment is DiffSegment => segment !== null && segment.text.length > 0)
    .map((segment, index) => ({
      ...segment,
      index,
    }));
}
